import { render, staticRenderFns } from "./BriefContentView.vue?vue&type=template&id=210f830c&scoped=true"
import script from "./BriefContentView.vue?vue&type=script&lang=js"
export * from "./BriefContentView.vue?vue&type=script&lang=js"
import style0 from "./BriefContentView.vue?vue&type=style&index=0&id=210f830c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f830c",
  null
  
)

export default component.exports